// extracted by mini-css-extract-plugin
export var imageZoom = "imagezoom-module--imageZoom--52ca3";
export var imageZoomCarouselContainer = "imagezoom-module--imageZoomCarouselContainer--4f0cb";
export var imageZoomContainer = "imagezoom-module--imageZoomContainer--3fadb";
export var imageZoomModal = "imagezoom-module--imageZoomModal--82e1c";
export var imageZoomModalContent = "imagezoom-module--imageZoomModalContent--532f1";
export var imageZoomModalControls = "imagezoom-module--imageZoomModalControls--a4f21";
export var imageZoomModalFooter = "imagezoom-module--imageZoomModalFooter--9616b";
export var imageZoomModalImage = "imagezoom-module--imageZoomModalImage--d74c7";